import * as types from '../actions/types';

const initialState = {
  isError: false,
  data: null,
  isRefresh: false
};

const cardsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_CARDS_REQUESTED:
      return {
        ...state,
        error: null
      };
    case types.GET_CARDS_SUCCEEDED:
      return {
        ...state,
        data: action.data,
        error: null
      };
    case types.GET_CARDS_FAILED:
      return {
        ...state,
        isError: true,
        data: null,
        error: action.error
      };
    case types.CREATE_CARD_REQUESTED:
      return {
        ...state,
        error: null
      };
    case types.CREATE_CARD_SUCCEEDED:
      return {
        ...state,
        data: action.data,
        error: null
      };
    case types.CREATE_CARD_FAILED:
      return {
        ...state,
        isError: true,
        data: null,
        error: action.error
      };
    case types.CREATE_SETUP_INTENT_REQUESTED:
      return {
        ...state,
        error: null
      };
    case types.CREATE_SETUP_INTENT_SUCCEEDED:
      return {
        ...state,
        data: action.data,
        error: null
      };
    case types.CREATE_SETUP_INTENT_FAILED:
      return {
        ...state,
        isError: true,
        data: null,
        error: action.error
      };
    case types.CHECK_SETUP_INTENT_COMPLETED_REQUESTED:
      return {
        ...state,
        error: null
      };
    case types.CHECK_SETUP_INTENT_COMPLETED_SUCCEEDED:
      return {
        ...state,
        data: action.data,
        error: null
      };
    case types.CHECK_SETUP_INTENT_COMPLETED_FAILED:
      return {
        ...state,
        isError: true,
        data: null,
        error: action.error
      };
    default:
      return state;
  }
};

export default cardsReducer;
